export default "__VITE_ASSET__TCDw0d5U__"